class Pagination extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('.js-pagination-button');
    this.prevPage = document.querySelector('[data-prev-page]').getAttribute('data-prev-page') || 0;
    this.nextPage = document.querySelector('[data-next-page]').getAttribute('data-next-page');
    this.items = document.querySelector('.js-items-grid');
    this.url = new URL(window.location.href);

    if (this.button) this.button.addEventListener('click', event => this.getSection(this.nextPage, event));

    window.addEventListener("load", () => this.updatePage());
  }

  updatePage() {
    this.url.searchParams.has('page')
      ? this.getPreviousPages()
      : this.removeFirstRowOfChildren()
  }

  getPreviousPages() {
    for (let i = Number(this.prevPage); i > 0; i--) this.getSection(i);
  }

  removeFirstRowOfChildren() {
    if (window.location.href.includes("tagged")) return;

    Array.from(this.items.childNodes).forEach((child, idx) => {
      if (idx <= 2) this.items.removeChild(child);
    });
  }

  getSection(page, event) {
    if (event) event.preventDefault();

    const pageUrl = this.getPageUrl(page);
    const section = this.getSectionUrl(pageUrl);

    this.button.classList.add('loading');

    fetch(section)
      .then(response => response.text())
      .then(data => this.updateSection(data, event))
      .then(() => this.updateHistory(event, pageUrl))
      .finally(() => this.button.classList.remove('loading'))
  }

  getPageUrl(page) {
    const path = window.location.href;
    const url = symbol => path + symbol + 'page=' + page;

    return path.includes('page=')
      ? this.setSearchParam(path, page)
      : path.includes('?')
        ? url('&')
        : url('?');
  }

  setSearchParam(path, page) {
    this.url.searchParams.set('page', page.toString());
    this.url.search = this.url.searchParams.toString();

    return this.url.toString();
  }

  getSectionUrl(page) {
    const section = document.querySelector('[data-pagination-section]').getAttribute('data-pagination-section');

    return page + '&section_id=' + section;
  }

  updateSection(section, event) {
    const dataHtml = new DOMParser().parseFromString(section, "text/html");
    const items = dataHtml.querySelector('.js-items-grid').childNodes;
    const pagination = dataHtml.querySelector('.js-pagination');

    if (items) event ? this.addNextPageItems(items, pagination) : this.addPreviousPageItems(items);
  }

  addNextPageItems(items, pagination) {
    while (items.length > 0) this.items.append(items[0]);

    document.querySelector('.js-pagination').replaceWith(pagination);
    document.querySelector('.image-content').remove();
  }

  addPreviousPageItems(items) {
    const reverse = this.reverseChildren(items);

    while (items.length > 0) this.items.prepend(reverse[0]);

    document.querySelector('.image-content').remove();
  }

  updateHistory(event, url) {
    if (event) window.history.pushState('', '', url);
  }

  reverseChildren(children) {
    for (let i = 1; i < children.length; i++) {
      children[0].parentNode.insertBefore(children[i], children[0]);
    }

    return children;
  }
}

customElements.define('infinite-pagination', Pagination);